import { Link } from '@tanstack/react-router'
import { IconName, IconSize } from 'ui/components'
import { AdverseMediaPaths } from '~bank-adverse-media/constants'

import { s } from './styles'

export const PageTitle = ({ title }: { title: string }) => (
  <s.Title>
    <Link to={AdverseMediaPaths.List}>
      <h1>Adverse Media </h1>
    </Link>
    <s.Arrow name={IconName.ARROW_SMALL} size={IconSize.XS} />
    <h1>{title}</h1>
  </s.Title>
)
